import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { connect} from "react-redux";
import useMedia from "use-media";
import constant from "../../const/Const";

import { favoriteApi, deleteFavoriteConditionsApi, versionGetApi } from "../../const"
import { ModalClose } from "../atoms/modalClose";
import { Button } from "../atoms/button";
import common from "../../resources/js/common/common"

const SavedSearchCriteriaContainer = (props) => {
    const { 
        login,
        course,
        detailCondition,
        favoriteCondition,
        startTime,
        setStartTime,
        setCourse,
        setDetailCondition,
        setFavoriteCondition,
        state,
        onClickOpenSavedSearchCriteriaWindow } = props;

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [display, setDisplay] = useState(false);
    const [courseName, setCourseName] = useState([]);
    const [teeTime, setTeeTime] = useState([]);
    const [detailName, setDetailName] = useState([]);
    const [apiData, setApiData] = useState();

    const startTimes = constant.START_TIMES;

    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);


    useEffect(() => {
        // common.doPost(versionGetApi, {}, afterVerCheck);
        getFavoriteConditions();
    },[props.state]);

    // お気に入り条件取得
    const getFavoriteConditions = () => {
        // post送信
        common.doPost(favoriteApi, { userid:login.memberCode}, afterGetFavoriteConditions);
    }

    // お気に入り条件取得後関数
    const afterGetFavoriteConditions = (res)=> {
        const conditions = res.data.favoriteConditions;
        if(conditions === undefined){
            setDisplay(false);
        }
        else{
            const condition = JSON.parse(conditions.condition);
            setDisplay(true);
            renderingProc(condition);
            setFavoriteCondition(condition);
        }
    }

    const renderingProc = (data) => {

        const golfCourseId = data.golfCourseId;
        const teeTime = data.teeTime;
        const detail = data.detail;

        const courseNameList = [];
        if(golfCourseId){
            for (let i in course) {
                if (golfCourseId.includes(course[i].id)) {
                    courseNameList.push(course[i].value);
                }
            }
        }

        const teeTimeNameList = [];
        if(teeTime){
            for (let i in startTime) {
                if (teeTime.includes(startTime[i].id)) {
                    teeTimeNameList.push(startTime[i].value);
                }
            }
        }

        const detailNameList = [];
        if(detail){
            for (let i in detailCondition) {
                if (detail.includes(detailCondition[i].id)) {
                    detailNameList.push(detailCondition[i].value);
                }
            }
        }

        setCourseName(courseNameList);
        setTeeTime(teeTimeNameList);
        setDetailName(detailNameList);
        setApiData(data);
    }

    // お気に入り条件反映
    const onClickDecide = () => {

        const teeTime = favoriteCondition.teeTime;
        startTimes.forEach((obj, idx)=>{
            if (teeTime.includes(obj.id)) {
                obj.checked = true;
            }
            else{
                obj.checked = false;
            }
        });

        const facility = favoriteCondition.golfCourseId;
        course.forEach((obj, idx)=>{
            if (facility.includes(obj.id)) {
                obj.checked = true;
            }
            else{
                obj.checked = false;
            }
        });

        const detail = favoriteCondition.detail;
        let detailChkBoxElem = document.getElementsByClassName("play_style");
        detailCondition.forEach((obj, idx)=>{
            const id = obj.id;
            const filtered = Array.prototype.filter.call(detailChkBoxElem,(elem)=>{return elem.value === id})[0];
            if(filtered !== undefined){
                if (detail.includes(id)) {
                    obj.checked = true;
                    filtered.checked = true;
                }
                else{
                    obj.checked = false;
                    filtered.checked = false;
                }
            }
            else{
                if (detail.includes(id)) {
                    obj.checked = true;
                }
                else{
                    obj.checked = false;
                }
            }
        });

        // スタート時間
        setStartTime(startTimes);
        // 施設startTimes
        setCourse(course);
        // 詳細条件
        setDetailCondition(detailCondition);

        onClickOpenSavedSearchCriteriaWindow();
    }

    // お気に入り条件削除
    const onClickDelete = ()=> {
        // post送信
        common.doPost(deleteFavoriteConditionsApi, { userid:login.memberCode}, afterDelete);
    }

    // お気に入り条件削除後
    const afterDelete = (res) => {
        getFavoriteConditions(res);
    }

    return (
        <div style={state ? style.popupIsShow : style.popup} id="js-popup">
            <div style={isMobilePhone ? style.popupInnerMobile : style.popupInner}>
                <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={onClickOpenSavedSearchCriteriaWindow}/>
                <h4 style={isMobilePhone ? style.popupInnerTextSp : style.popupInnerText}>保存した検索条件</h4>
                {/* {display ? ( */}
                    <>
                        <div style={isMobilePhone ? style.tableMobile : style.table}>
                            {/* 後でコメントアウト外す */}
                            <div style={style.tableRow}>
                            <div style={isMobilePhone ? style.tableColHeadingSp : style.tableColHeading}>ゴルフ場</div>
                                {courseName.map((item, index) => (<div key={index} style={style.tableColBody}>{display ? item : null}</div>))}
                            </div>
                            <div style={style.tableRow}>
                                <div style={isMobilePhone ? style.tableMobileColHeading : style.tableColHeading}>プレースタイル</div>
                                <div style={style.tableColBody2}>
                                    {display ? detailName.map((item,index)=>((index!==0)&&(detailName.size!==index+1)?"／":"")+item) : null}
                                </div>
                            </div>
                            <div style={style.tableRowLast}>
                                <div style={style.tableColHeadingLast}>スタート時間</div>
                                <div style={isMobilePhone ? style.tableColBodyLastSp : style.tableColBodyLast}>
                                    {display ? teeTime.map((item,index)=>((index!==0)&&(teeTime.size!==index+1)?"／":"")+item) : null}
                                </div>
                            </div>
                        </div>
                        {display ?
                        <div style={isMobilePhone ? style.buttonAreaMobile : style.buttonArea}>
                            <Button buttonText="決定" className={"selectBtn"} onClick={onClickDecide} />
                            <p style={style.deleteCriteria} onClick={onClickDelete}>この条件を削除</p>
                        </div>
                        :
                        <div style={isMobilePhone ? style.buttonAreaMobile : style.closeButtonArea}>
                            <Button buttonText="閉じる" className={"selectBtn"} onClick={onClickOpenSavedSearchCriteriaWindow} />
                        </div>
                        }
                    </>
            </div>
            <div style={style.blackBackground} id="js-black-bg"></div>
        </div>
    );
};
const style = {
    popup: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "0",
        visibility: "hidden",
        transition: ".6s",
    },
    popupIsShow: {
        position: "fixed",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        zIndex: "9999",
        opacity: "1",
        visibility: "visible",
        transition: ".6s",
    },
    popupInner: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerClose: {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        width: "50%",
        backgroundColor: "#fff",
        zIndex: "2",
        height: "30%",
    },
    popupInnerMobile: {
        position: "absolute",
        left: "50%",
        bottom: "0%",
        transform: "translate(-50%, 0%)",
        width: "100%",
        backgroundColor: "#fff",
        zIndex: "2",
    },
    popupInnerText: {
        width: "100%",
        textAlign: "center",
    },
    popupInnerTextSp: {
        width: "100%",
        textAlign: "center",
        borderBottom:"1px solid #eee",
        margin:0,
        padding:"20px 0px 20px 0px"
    },
    table: {
        display: "table",
        width: "60%",
        margin: "30px auto",
        borderCollapse:"collapse"
    },
    tableMobile: {
        display: "table",
        width: "90%",
        margin: "40px auto",
        borderCollapse:"collapse"
    },
    tableRow: {
        display: "table-row",
        borderBottom:"solid 1px rgb(173, 173, 173)"
    },
    tableRowLast: {
        display: "table-row",
    },
    tableColHeading: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        paddingBottom: "30px",
        fontSize: "small",
        width:"33%"
    },
    tableColHeadingSp: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingBottom: "30px",
        fontSize: "small",
        width:"33%"
    },
    tableMobileColHeading: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        paddingBottom: "30px",
        fontSize: "small",
        width:"41%"
    },
    tableColBody: {
        fontSize: "small",
    },
    tableColBody2: {
        display:"table-cell",
        fontSize: "small",
    },
    tableColHeadingLast: {
        display: "table-cell",
        fontWeight: "bold",
        paddingRight: "40px",
        paddingTop: "30px",
        paddingBottom: "40px",
        fontSize: "small",
    },
    tableColBodyLast: {
        display: "table-cell",
        paddingTop: "40px",
        paddingBottom: "40px",
        fontSize: "small",
    },
    tableColBodyLastSp: {
        display: "table-cell",
        paddingTop: "40px",
        fontSize: "small",
    },
    blackBackground: {
        position: "absolute",
        left: "0",
        top: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, .8)",
        zIndex: "1",
    },
    buttonArea: {
        width: "60%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "40px",
    },
    closeButtonArea: {
        width: "60%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // height: "50%",
    },
    buttonAreaMobile: {
        width: "90%",
        textAlign: "center",
        margin: "auto",
        paddingBottom: "15px",
    },
    deleteCriteria: {
        color: "#adadad",
        textAlign: "right",
        textDecoration: "underline",
        fontSize: "small",
        cursor:"pointer",
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.login,
        playDate1: state.playDate1,
        course: state.course,
        startTime: state.startTime,
        detailCondition: state.detailCondition,
        favoriteCondition: state.favoriteCondition
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setFavoriteCondition:(condition)=>{
            dispatch({ type: "FAVORITE_CONDITION", payload:{ favoriteCondition: condition} });
        },
        setStartTime: (item) => {
            dispatch({ type: "START_TIME", payload: { startTime: item } })
        },
        setCourse: (item) => {
            dispatch({ type: "COURSE", payload: { course: item } })
        },
        setDetailCondition: (item) => {
            dispatch({ type: "DETAIL_CONDITION", payload: { detailCondition: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(SavedSearchCriteriaContainer);